import { CheckCircle2, ShieldCheck, MapPin, Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { STATS } from "@/data/site";

const ICONS = { CheckCircle2, ShieldCheck, MapPin, Star };

export default function Stats() {
  return (
    <section className="relative py-16 sm:py-20" data-testid="stats-section" aria-label="AzoApp trust stats">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[2rem] border border-azo-border bg-azo-primary shadow-azo">
          <div className="pointer-events-none absolute -top-24 -right-16 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-azo-accent/30 blur-3xl" />
          <div className="relative grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/15 divide-y lg:divide-y-0">
            {STATS.map((s, i) => {
              const Icon = ICONS[s.icon] || Star;
              return (
                <Reveal key={s.label} delay={i * 0.1} className="p-8 sm:p-10 text-center text-white">
                  <span className="inline-grid h-12 w-12 place-items-center rounded-2xl bg-white/12 mb-4">
                    <Icon size={22} />
                  </span>
                  <p className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl leading-none tracking-tight">
                    {s.value}
                  </p>
                  <p className="mt-2 text-xs sm:text-sm text-white/75 font-medium">{s.label}</p>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
